import React from 'react';

interface Props {
  id: string;
}

export const CarrierPayment = ({ id, }:Props) => {
  return (
    <div>
      płatności { id }
    </div>
  );
};
